module.exports = __webpack_public_path__ + "static/media/33 Stand Up.9d86c4e1.jpg";